import * as Lucide from 'lucide-react';
import Reveal from './Reveal';
import { whyUs } from '../mock';

const WhyUs = () => {
  return (
    <section className="relative py-28 lg:py-36 px-6 lg:px-10 bg-card/40">
      <div className="max-w-[1300px] mx-auto">
        <Reveal>
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-clay" />
            <span className="text-[11px] tracking-[0.28em] text-clay font-medium">
              NEDEN MEMBRATEK
            </span>
            <span className="h-px w-10 bg-clay" />
          </div>
          <h2 className="text-[40px] sm:text-[48px] lg:text-[56px] leading-[1.05] font-semibold text-white max-w-4xl mx-auto">
            Dikkatli Planlama, Mukemmel Sonuclar
          </h2>
          <p className="mt-5 text-[15px] text-white/55 max-w-xl mx-auto">
            Mukemmellik yaratma arzumuzla, kullanimi kolay, uzun sureli ve ozel projeler sunuyoruz.
          </p>
        </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
          {whyUs.map((item, i) => {
            const Icon = Lucide[item.icon] || Lucide.Star;
            return (
              <Reveal key={item.title} variant="up" delay={i * 90}>
              <div className="group relative">
                <div className="text-[88px] sm:text-[100px] font-bold text-white/[0.06] leading-none tracking-tight select-none transition-colors duration-500 group-hover:text-primary/15">
                  {item.number}
                </div>
                <div className="mt-[-30px] relative">
                  <Icon size={26} strokeWidth={1.4} className="text-accent mb-5" />
                  <h3 className="text-[19px] font-semibold text-white mb-3">
                    {item.title}
                  </h3>
                  <p className="text-[13.5px] text-white/55 leading-relaxed max-w-[260px]">
                    {item.description}
                  </p>
                  <div className="mt-5 h-[2px] w-10 bg-clay group-hover:w-16 transition-all duration-500" />
                </div>
              </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
